import React, { useState, useEffect } from 'react';

const InputPlaneacion = (p) => {
    const isInput = p.input ? true : false;
    const typeInput = p.typeInput ?? 'text';
    const name = p.name;
    const value = p.value ? p.value : typeInput === 'text' ? "" : 0;
    const className = p.className ?? 'form-control form-control-sm m-0 ';
    const options = p.options ?? [];
    const disabled = p.disabled;
    const cambiar = (e) => { if (p.funcion) p.funcion(e); };
    if (isInput) return (<input type={typeInput} name={name} className={className} value={value} onChange={cambiar} disabled={disabled} />);

    return (
        <select className={className} name={name || ""} value={value || ""} onChange={cambiar} disabled={disabled}>
            <option value=''>Seleccionar</option>
            {
                options.map((reg, i) => {
                    return <option key={i + "index"} value={reg.key}>{reg.name}</option>
                })
            }
        </select>
    )
}

export default InputPlaneacion;